import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getIdentityCards(options = {}) {
	return _apiRequestWrap(
		ModulesMap.IDENTITY_CARDS,
		ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARDS,
		options
	)
}
function _getIdentityPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.IDENTITY_CARDS,
		ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARDS_PREVIEW,
		options
	)
}
function _createIdentityCard(options = {}) {
	return _apiRequestWrap(
		ModulesMap.IDENTITY_CARDS,
		ModulesConfigMap[ModulesMap.IDENTITY_CARDS].CREATE_IDENTITY_CARD,
		options
	)
}
function _deleteIdentityCard(options = {}) {
	return _apiRequestWrap(
		ModulesMap.IDENTITY_CARDS,
		ModulesConfigMap[ModulesMap.IDENTITY_CARDS].DELETE_IDENTITY_CARD,
		options
	)
}
function _getIdentityCard(options = {}) {
	return _apiRequestWrap(
		ModulesMap.IDENTITY_CARDS,
		ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARD,
		options
	)
}
function _patchIdentityCard(options = {}) {
	return _apiRequestWrap(
		ModulesMap.IDENTITY_CARDS,
		ModulesConfigMap[ModulesMap.IDENTITY_CARDS].PATCH_IDENTITY_CARD,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARDS]: _getIdentityCards,
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARDS_PREVIEW]: _getIdentityPreview,
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].CREATE_IDENTITY_CARD]: _createIdentityCard,
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].DELETE_IDENTITY_CARD]: _deleteIdentityCard,
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARD]: _getIdentityCard,
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].PATCH_IDENTITY_CARD]: _patchIdentityCard,

}